// extracted by mini-css-extract-plugin
export var orderSummary = "_sy-0";
export var showMoreLessButton = "_sy-1";